import { AnswerButtonHelper } from '~/training/sequence/templates/translators/itemHelpers/AnswerButtonHelpers';
import {
  LayoutColumnsDefinition,
  LayoutListDefinition,
  LAYOUT_COLUMNS,
  LAYOUT_LIST,
  QUIZ_CHOICE,
  TEXT
} from '../items';
import { Translator } from '../Translator';
import { PhoneHelper } from './itemHelpers/PhoneHelper';
import { ItemOfType } from './itemHelpers/types';
import { quizLegendText } from './itemHelpers/Quiz';
import { translate } from './translate';

export const SocialMedia9: Translator = sequence => {
  const columns = {
    type: LAYOUT_COLUMNS,
    id: `${sequence.id}-columns`,
    items: [],
    values: {}
  } as LayoutColumnsDefinition;

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'Phone':
        columns.items.push(
          PhoneHelper(
            item as ItemOfType<'Phone'>,
            sequence,
            sequence?.personalization
          )
        );
        break;

      case 'Question':
        columns.items.push({
          id: item.id,
          type: LAYOUT_LIST,
          values: { align: 'left', height: { _: 'auto', lg: '100%' } },
          items: [
            {
              type: TEXT,
              id: `${item.id}_subtitle`,
              items: [],
              values: {
                value: item.subtitle,
                variant: 'sub_heading',
                icon: item.icon
              }
            },
            {
              type: TEXT,
              id: `${item.id}_title`,
              items: [],
              values: {
                value: item.title,
                variant: 'heading1'
              }
            },
            {
              type: TEXT,
              id: `${item.id}_body`,
              items: [],
              values: {
                value: item.body
              }
            },
            {
              type: QUIZ_CHOICE,
              id: '1',
              values: {
                variant: item.items && item.items.length > 2 ? 'list' : '',
                title: quizLegendText(item.title, item.body),
                length: item?.items?.length,
                multiSelect: item?.items?.filter(item => item.correct === true)
                  .length
              },
              items: AnswerButtonHelper({
                group: item.id,
                items: item.items,
                llamaSurvey: item.llamaSurvey,
                question: item.title || ''
              })
            }
          ]
        } as LayoutListDefinition);
    }
    return null;
  });

  root.items.push(columns);
  return root;
};
